import React from 'react';
import PropTypes from 'prop-types';
import { StudentInfoCell } from '../../components/cell/shared/Cells';
import ListTable from '../../components/listTable/ListTable';
import { TBL_KEYS, TBL_COLUMN_TITLES } from '../../constants/shared/InstructionConstants';
import { TABLE_MEASUREMENTS, COLUMN_WIDTH } from '../../constants/shared/ListTableConstants';
import './StudentListTable.scss';

const { NAME, OVERALL } = TBL_KEYS;

const buildColumns = columns => {
    const columnsData = [];
    const isThereAdditionalColumns = columns.some(clm => clm !== NAME);

    columns.forEach(key => {
        if (key === NAME) {
            columnsData.push({
                dataKey: NAME,
                label: <>{TBL_COLUMN_TITLES[key]}</>,
                width: isThereAdditionalColumns
                    ? COLUMN_WIDTH.STUDENT_NAME_COLUMN
                    : COLUMN_WIDTH.FIRST_COLUMN,
                headerClassName: `border-left-0 ${!isThereAdditionalColumns && 'single-name'}`,
            });
        } else {
            columnsData.push({
                dataKey: key,
                label: <>{TBL_COLUMN_TITLES[key]}</>,
                width: COLUMN_WIDTH.ADDITIONAL_COLUMN,
            });
        }
    });
    return columnsData;
};
const buildRows = (studentsData, columns, additionalRowDataRenderer) => {
    const isThereAdditionalColumns = columns.some(clm => clm !== NAME);

    return studentsData.map(({ studentInfo, bmStatuses }) => {
        const { id, firstName, lastName } = studentInfo;
        const rowData = {
            id,
        };
        columns.forEach(key => {
            if (key === NAME) {
                rowData[NAME] = (
                    <StudentInfoCell
                        classNames={`cell name ${isThereAdditionalColumns && 'fixed-row-width'}`}
                        firstName={firstName}
                        lastName={lastName}
                    >
                        {`${lastName}, ${firstName}`}
                    </StudentInfoCell>
                );
            } else {
                rowData[key] = (
                    <div className="cell additional-column">
                        {additionalRowDataRenderer(key, bmStatuses)}
                    </div>
                );
            }
        });
        return rowData;
    });
};

const StudentListTable = ({
    studentsData,
    selectedStudentId,
    selectStudentId,
    additionalRowDataRenderer,
    columns,
    onSort,
}) => (
    <div className="students-table-wrap">
        <ListTable
            isSortable={columns.length === 1}
            tableData={studentsData}
            buildRows={data => buildRows(data, columns, additionalRowDataRenderer)}
            buildColumns={() => buildColumns(columns)}
            selectedItemId={selectedStudentId}
            onRowClick={selectStudentId}
            onHeaderClick={onSort}
            measurements={
                columns.includes(OVERALL)
                    ? TABLE_MEASUREMENTS.STUDENTS_WITH_OVERALL
                    : TABLE_MEASUREMENTS.DEFAULT
            }
            onSort={onSort}
        />
    </div>
);

StudentListTable.defaultProps = {
    studentsData: [],
    columns: [NAME],
    selectedStudentId: null,
    selectStudentId: () => {},
    additionalRowDataRenderer: () => {},
    onSort: () => {},
};

StudentListTable.propTypes = {
    studentsData: PropTypes.array,
    columns: PropTypes.array,
    selectedStudentId: PropTypes.string,
    selectStudentId: PropTypes.func,
    additionalRowDataRenderer: PropTypes.func,
    onSort: PropTypes.func,
};

export default StudentListTable;
